import { Box, Flex, Image, Text } from '@bfa/common-ui';
import React from 'react';

import { GQLSimpleImage } from '../../../../gql.generated';

const PaymentMethod = ({
  icon,
  description,
}: {
  icon?: GQLSimpleImage | null;
  description?: string | null;
}) => {
  return (
    <Flex alignItems="center" justifyContent="center">
      {icon && (
        <Box width="7rem" marginRight="1rem">
          <Image
            src={icon.src}
            alt={icon.alt}
            aspectRatio={[icon.width ?? 4, icon.height ?? 3]}
          />
        </Box>
      )}
      {description && <Text>{description}</Text>}
    </Flex>
  );
};

export default PaymentMethod;
